/*
 * @Description: 登录
 * @Date: 2024-11-05 09:46:11
 */

import { route } from './src/router';

const name = 'login';

export { name, route };
